<div *ngIf="office">
  <div mat-dialog-title>
    <div *ngIf="office.office_ID" i18n>Edit Office</div>
    <div *ngIf="!office.office_ID" i18n>Add Office</div>
  </div>
  <div class="form-inline mb-3">
    <span *ngIf="office.office_ID" i18n>Make the necessary changes on the form below then click Submit</span>
    <span *ngIf="!office.office_ID" i18n>To add a new office, complete the form below then click Submit.</span>
    <span class="float-right warning col-sm-5" i18n>* Required Information</span>
  </div>
  <form #form="ngForm" (ngSubmit)="saveOffice(form)">
    <div mat-dialog-content>
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="col-form-label" for="name" i18n>Office Name</label>
            <input id="name" name="name" class="form-control" [(ngModel)]="office.office_Name"
                   required #name="ngModel"
                   [class.field-error]="form.submitted && name.invalid">
            <div [hidden]="!form.submitted || name.valid" class="alert alert-danger" i18n>
              Office name is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="col-form-label" for="address1" i18n>Address 1</label>
            <input id="address1" name="address1" class="form-control" [(ngModel)]="office.office_Address1"
                   required #address1="ngModel"
                   [class.field-error]="form.submitted && address1.invalid">
            <div [hidden]="!form.submitted || address1.valid" class="alert alert-danger" i18n>
              Address Line 1 is required
            </div>
          </div>
          <div class="control-wrapper">
            <label class="col-form-label" for="address2" i18n>Address (2)</label>
            <input id="address2" name="address2" class="form-control" [(ngModel)]="office.office_Address2"
                   #address2="ngModel"
                   [class.field-error]="form.submitted && address2.invalid">
            <div [hidden]="!form.submitted || address2.valid" class="alert alert-danger" i18n>
              Address Line 2 is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="col-form-label" for="city" i18n>City</label>
            <input id="city" name="city"
                   required
                   placeholder="City"
                   i18n-placeholder
                   class="form-control"
                   [(ngModel)]="office.office_City"
                   #city="ngModel"
                   [class.field-error]="form.submitted && city.invalid">
            <div [hidden]="!form.submitted || city.valid" class="alert alert-danger" i18n>
              City is required
            </div>
          </div>
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="col-form-label" for="state" i18n>State</label>
            <select [(ngModel)]="office.office_State" name="state" id="state" class="form-control select-bidit" required #state="ngModel"
                    [class.field-error]="form.submitted && state.invalid">
              <option value="" selected="">-</option>
              <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
            </select>
            <div [hidden]="!form.submitted || state.valid" class="alert alert-danger" i18n>
              State is required
            </div>
          </div>
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="col-form-label" for="postal" i18n>Zip</label>
            <input id="postal" name="postal"
                   required
                   placeholder="Zip"
                   i18n-placeholder
                   class="form-control"
                   [(ngModel)]="office.office_Postal"
                   #postal="ngModel" />
            <div [hidden]="!form.submitted || postal.valid" class="alert alert-danger" i18n>
              Enter a valid zip code
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <label for="email" i18n>Email</label>
            <input id="email" name="email" type="email"
                   placeholder="Email"
                   i18n-placeholder
                   class="form-control"
                   [(ngModel)]="office.office_Email"
                   #email="ngModel" />
            <div [hidden]="!form.submitted || email.valid" class="alert alert-danger" i18n>
              Enter a valid email
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </mat-dialog-actions>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
    <div class="mt-3">
      <div [hidden]="!form.submitted || form.valid"
           class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    </div>
  </form>
</div>
